import { createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { ApiProvider } from "../ApiProvider";
import { createAppAsyncThunk } from "../hooks";
import { getInitialState } from "../helpers";

const suggestedTagsInitialState = getInitialState<Array<string>>([]);

export const getSuggestedTags = createAppAsyncThunk<Array<string>, { suggestion: string; limit?: number }>(
	"suggestedTags/getSuggestedTags",
	async (payload, { rejectWithValue, signal }) => {
		try {
			const { suggestion, limit = 6 } = payload;
			const api = ApiProvider.default.axios;

			const res = await api.get<Array<string>>(`/api/System/ListItemTags?suggestion=${suggestion}&limit=${limit}`, { signal });
			const data = Array.isArray(res.data) ? res.data.filter((x) => x) : [];

			return data;
		} catch (error) {
			let msg = "";
			if (error instanceof AxiosError) {
				msg = error.message;
			}
			return rejectWithValue(msg);
		}
	},
);

export const suggestedTagsSlice = createSlice({
	name: "suggestedTags",
	initialState: suggestedTagsInitialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getSuggestedTags.pending, (state) => {
				state.loading = true;
				state.isInitialLoad = false;
			})
			.addCase(getSuggestedTags.fulfilled, (state, action) => {
				state.loading = false;
				state.version++;
				state.init = true;
				state.data = action.payload;
				state.error = null;
			})
			.addCase(getSuggestedTags.rejected, (state, action) => {
				state.loading = false;
				state.error = `${action.payload}`;
			});
	},
});
